const IDLE_KEY = 'sessionIdleTimeoutMin';

/** Store the tenant's admin idle timeout (Site Settings → Security) returned at sign-in / refresh. */
export function rememberSessionPolicy(session?: { idleTimeoutMin?: number } | null) {
  const min = Number(session?.idleTimeoutMin);
  if (Number.isFinite(min) && min > 0) localStorage.setItem(IDLE_KEY, String(min));
  else if (session === undefined) localStorage.removeItem(IDLE_KEY);
}

export function sessionIdleTimeoutMin(): number | null {
  const min = Number(localStorage.getItem(IDLE_KEY));
  return Number.isFinite(min) && min > 0 ? min : null;
}
